import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useEntityFromRoute } from '../hooks/route/useEntityFromRoute';
import { useNavState } from '../navState/NavStateContext';
import { SideNavButton } from './SideNavButton';

export const HelpButton = () => {
  const location = useLocation();
  const routeEntity = useEntityFromRoute();
  const { navigateTo } = useNavState();

  const navigateToHelpScreen = (entity) => {
    let url = '/admin/help';

    navigateTo(url, { entity: entity }, true);
  };

  // Global F1 shortcut to open Help with route-derived context when available.
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key !== 'F1') return;

      event.preventDefault();

      navigateToHelpScreen(routeEntity);
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [location.pathname, routeEntity]);

  return <SideNavButton onClick={() => navigateToHelpScreen()} icon={fas.faCircleQuestion} />;
};
